
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { jk } from '@/authors'
export const meta = {
  title: 'January Product Updates',
  description: `
Thanks for being great support to us with patience and feedbacks to improve the ecosystem. Every suggestions you give us always help your fellow entreprenuers as well. `,
  date: '2021-01-18T15:43:02.988Z',
  authors: [jk]
};
export const slug = '2021-01-18-january';
export const tableOfContents = [{
  "title": "Account Approval",
  "slug": "account-approval",
  "children": []
}, {
  "title": "Attribute Enhancement",
  "slug": "attribute-enhancement",
  "children": []
}];

const layoutProps = {
  meta,
slug,
tableOfContents
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p>{`Thanks for being great support to us with patience and feedbacks to improve the ecosystem. Every suggestions you give us always help your fellow entreprenuers as well. `}</p>
    <p>{`Here is update for January so far:`}</p>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Attributes enhancement (public-private, file attachment attribute)`}</li>
      <li parentName="ol">{`Account Approval is live on production`}</li>
    </ol>
    <p>{`Note: If you want to activate this feature, let us know on slack for now. We will add this into SuperAdmin settings soon. `}</p>
    <_Heading level={2} id={"account-approval"} nextElement={{
      "type": "paragraph"
    }}>Account Approval</_Heading>
    <p>{`As a marketplace operators, you will be able to do a KYC process before approving stores to be shown in the marketplace. A bigger marketplace wants to regulate everything happening in it’s business`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Marketplace owner able to approve a store in superadmin panel similar to our existing listing approval`}</li>
      <li parentName="ul">{`You can activate auto approval or manual approval based on your performance`}</li>
      <li parentName="ul">{`Until the store is activated, a seller account will not be visible in the marketplace from feed to search`}</li>
      <li parentName="ul">{`A seller will have a label in his shop to see the account approval status`}</li>
    </ul>
    <_Heading level={2} id={"attribute-enhancement"} nextElement={{
      "type": "paragraph"
    }}>Attribute Enhancement</_Heading>
    <p>{`Every new attribute type is an opportunity for marketplace to increase user experience`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Now you can get file attachment on account level or listing level. This will help you to do activities from KYC process to simple file verification `}</li>
      <li parentName="ul">{`You can make attribute as private or public. Use cases like private data you want to gather from accounts/storeowners `}</li>
    </ul>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;